import styled from 'styled-components';

export type ContainerProps = {
  itemSize: {
    width?: number;
    height?: number;
    gap?: number;
  };
  listCounts: number;
  speed?: number;
  direction?: 'row' | 'column';
  ifStart?: boolean;
};

export const InfiniteScrollContainer = styled.div<ContainerProps>`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;

  --list-wrapper-width: ${({ itemSize: { width = 0, gap = 0 }, listCounts, direction = 'row' }) =>
    direction === 'row' ? `${listCounts * (width + gap)}px` : '100%'};
  --list-wrapper-height: ${({ itemSize: { height = 0, gap = 0 }, listCounts, direction = 'row' }) =>
    direction === 'column' ? `${listCounts * (height + gap)}px` : '100%'};
  --list-content-wrapper-width: ${({ direction = 'row' }) =>
    direction === 'row' ? `calc(2 * var(--list-wrapper-width))` : '100%'};
  --list-content-wrapper-height: ${({ direction = 'row' }) =>
    direction === 'column' ? `calc(2 * var(--list-wrapper-height))` : '100%'};
  --animation: ${({ direction = 'row' }) =>
    direction === 'row'
      ? 'slideRow var(--speed) linear infinite normal'
      : 'slideColumn var(--speed) linear infinite normal'};
  --speed: ${props => props.speed ?? 5}s;
  --animation-state: ${props => (props.ifStart ? 'running' : 'paused')};

  .list-wrapper {
    display: flex;
    width: var(--list-wrapper-width);
    height: var(--list-wrapper-height);
    overflow: hidden;
    position: relative;

    .list-content-wrapper {
      position: absolute;
      width: var(--list-content-wrapper-width);
      height: var(--list-content-wrapper-height);
      left: 0px;
      top: 0px;
      animation: var(--animation);
      animation-play-state: var(--animation-state);
    }
  }

  @keyframes slideRow {
    from {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    to {
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }
  }

  @keyframes slideColumn {
    from {
      -webkit-transform: translateY(0);
      transform: translateY(0);
    }
    to {
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }
`;
